import script from "./ScoreManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreManagement.vue?vue&type=script&setup=true&lang=js"

import "./ScoreManagement.vue?vue&type=style&index=0&id=06948952&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06948952"]])

export default __exports__